<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ "Migrate Customer" }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <template
          v-if="
            $can('create', 'Customer Loyalty Points') ||
            $can('update', 'Customer Loyalty Points')
          "
        >
          <button
            class="btn-blue p-2 w"
            @click="$bvModal.show('uploadCustomerModal')"
          >
            {{ $t("Upload Customer") }}
          </button>
        </template>

        <div class="mx-2"></div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="white-wrapper">
      <div
        class="w-100 d-flex align-items-center justify-content-end"
        style="margin-top: -13px"
      >
        <div class="d-flex align-items-center mr-3">
          <label class="mr-2 fs-12">{{ "Show Customers With Points" }}</label>
          <b-form-checkbox
            class="mb-2"
            style="zoom: 0.7"
            v-model="showCustomerWithBalance"
            unchecked-value="N"
            value="Y"
            switch
            @change="getCustomerLoyaltyPoints"
          ></b-form-checkbox>
        </div>

        <p class="error_message">
          <span></span>
        </p>
      </div>
      <div class="swc-report">
        <table
          class="swc-report-table border"
          border="1"
          style="border: 1px solid #444648 !important"
        >
          <thead class>
            <tr>
              <th class="text-left">USER ID</th>
              <th class="text-left">USER NAME</th>
              <th class="text-left">USER FIRST NAME</th>
              <th class="text-left">USER LAST NAME</th>
              <th class="text-left">USER EMAIL</th>
              <th class="text-left">USER PASSWORD</th>
              <th class="text-left">USER GENDER</th>
              <th class="text-left">VERIFIED</th>
              <th class="text-left">MOBILE</th>
              <th class="text-left">ROLE ID</th>
            </tr>
          </thead>

          <tbody v-if="excelReaderData && excelReaderData.length > 0">
            <tr
              v-for="(customerlist, customerlistIndex) in excelReaderData"
              :key="customerlistIndex"
              class="light_grey_back"
            >
              <td>{{ customerlist["user_id"] || "-" }}</td>
              <td>{{ customerlist["user_name"] || "-" }}</td>
              <td>{{ customerlist["user_first_name"] || "-" }}</td>
              <td>{{ customerlist["user_last_name"] || "-" }}</td>
              <td>{{ customerlist["user_email"] || "-" }}</td>
              <td>{{ customerlist["user_password"] || "-" }}</td>
              <td>{{ customerlist["user_gender"] || "-" }}</td>
              <td>{{ customerlist["verified"] || "-" }}</td>
              <td>{{ customerlist["user_mobile"] || "-" }}</td>
              <td>{{ customerlist["role_id"] || "-" }}</td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="8">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <b-modal
      id="uploadCustomerModal"
      title="Upload Customer"
      hide-header
      hide-footer
      ref="uploadCustomerModal"
    >
      <div class="col-12 text-center mb-4 pb-2 mt-3">
        <h4>{{ $t("Upload Customer") }}</h4>
      </div>

      <div class="col-lg-12 col-xl-12 mt-4 mb-1">
        <input type="file" placeholder="." @change="onChange" />
      </div>

      <div class="col-lg-12 col-xl-12 mb-1 text-center">
        <button
          @click.prevent.stop="updateData"
          class="btn-blue"
          v-if="this.excelReaderData.length"
        >
          {{ $t("Submit") }}
        </button>
        <button
          @click.prevent.stop="$bvModal.hide('uploadCustomerModal')"
          class="btn-blue"
        >
          Cancel
        </button>
      </div>
    </b-modal>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import Countries from "@/helper/formJSONMaster/Countries";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      customerloyaltypoints: [],
      showCustomerWithBalance: "N",
      debounce: null,
      searchValue: "",
      file: "",
      excelReaderData: [],
      Methods: Countries.Methods,
      country_code: "",
      customer_id: null,
      adminCredit: {
        customer_id: null,
        amount: 0,
        remark: "",
        selected_action: "Add Points",
      },
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    const { customer_id = null } = this.$route.query;
    if (customer_id) {
      this.customer_id = customer_id;
    }

    // this.getCustomerLoyaltyPoints();
    this.getviewingnumber();
  },
  methods: {
    openUpdateLoyality(customer_id) {
      if (customer_id) {
        this.adminCredit["customer_id"] = customer_id;
        this.$bvModal.show("credit-debit");
      }
    },
    updateBalance() {
      if (isNaN(this.adminCredit.amount)) {
        this.$toasted.show("Please enter a valid amount.");
        return;
      } else if (this.adminCredit.amount == 0) {
        this.$toasted.show("Please Enter Amount.");
        return;
      } else {
        let payload = {};
        if (this.adminCredit.selected_action == "Add Points") {
          payload = {
            customer_id: this.adminCredit["customer_id"] || null,
            amount: +parseFloat(this.adminCredit.amount || 0).toFixed(2),
            remark: this.adminCredit.remark || "",
            type: 1,
          };
        } else if (this.adminCredit.selected_action == "Deduct Points") {
          payload = {
            customer_id: this.adminCredit["customer_id"] || null,
            amount: +parseFloat(this.adminCredit.amount || 0).toFixed(2),
            remark: this.adminCredit.remark || "",
            type: 2,
          };
        } else {
          this.$toasted.show("Please Select Action Type");
          return false;
        }

        MarketingService.updateLoyalityPoints(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$bvModal.hide("credit-debit");
              this.currentPage = 1;
              this.getCustomerLoyaltyPoints();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    getCountryList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :", data);
            this.country_code = data.details[0].country_mob_code;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    updateData() {
      let body = {
        excelReaderData: this.excelReaderData,
      };

      let loader = this.$loading.show();

      MarketingService.migrateCustomersTestDONOTRUN(body)
        .then((response) => {
          const { data } = response;
          loader.hide();
          this.$refs["uploadCustomerModal"].hide();
          if (data.status) {
            this.$toasted.show("Uploading....");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
          loader.hide();
          this.$refs["uploadCustomerModal"].hide();
          this.$toasted.show("Uploading....");
        });
    },
    onChange(event) {
      console.log(event.target.files);
      this.file = event.target.files ? event.target.files[0] : null;
      this.file = event.target.files ? event.target.files[0] : null;
      this.excelReaderData = [];

      let array = [
        "user_first_name",
        "user_last_name",
        "user_gender",
        "user_dob",
        "user_mobile",
        "user_email",
        "created_at",
        "user_id",
        "is_active",
        "cinema_id",
        "mobile_verified",
        "is_delete",
      ];
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          console.log(data, "HEREsjhfjdh");

          data.map((z, index) => {
            if (index) {
              let obj = {
                is_loyality_subscribe: "Y",
                hideModalIfFound: false,
                cust_id: null,
                country_mob_code: this.country_code,
              };
              let array2 = [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11];
              z.map((y, index2) => {
                let findIndex2 = array2.indexOf(index2);
                if (findIndex2 >= 0) {
                  array2.splice(findIndex2, 1);
                }
                if (array[index2]) {
                  obj[array[index2]] =
                    y || (index2 == 4 ? 0 : index2 == 1 ? "-" : null);
                }
              });
              //   if (array2) {
              //     array2.map((k) => {
              //       obj[array[k]] = k == 4 ? 0 : k == 1 ? "-" : null;
              //     });
              //   }

              this.excelReaderData.push(obj);
            }
          });
          console.log(this.excelReaderData, "Before");

          this.excelReaderData = this.excelReaderData.filter((z) => {
            return z.user_first_name && z.user_mobile;
          });
          console.log(this.excelReaderData);
        };

        reader.readAsBinaryString(this.file);
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        // { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
      } else {
        this.selectedvalue = event;
        this.perPage = event;
      }
      this.onChangePagination();
    },
    onSearchCustomerLoyality() {
      this.currentPage = 1;
      this.getCustomerLoyaltyPoints();
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomerLoyaltyPoints();
      } else {
        this.currentPage = event;
        this.getCustomerLoyaltyPoints();
      }
    },
    getCustomerLoyaltyPoints: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        showCustomerWithBalance: this.showCustomerWithBalance,
      };

      if (this.customer_id) {
        body["customer_id"] = this.customer_id;
      }

      let loader = this.$loading.show();

      MarketingService.GetCustomerLoyaltyPoints(body)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.customerloyaltypoints = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
          let Operation_country_id = (
            this.$store.getters.getGlobalOptions || []
          ).filter((z) => {
            return z.go_key == "OPERATION_COUNTRY";
          });
          if (Operation_country_id.length) {
            this.getCountryList(Operation_country_id[0].go_value);
          }
          console.log(Operation_country_id, "getGlobalOptions");
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
        });
    },
    /* eslint-disable */
    onViewUser: function (user) {
      this.$router.push({
        path: "/user-management/view-user",
        query: { user_id: user.user_id },
      });
    },
  },
};
</script>

<style scoped>
.swc-report .swc-report-table th,
td {
  border-bottom: 1px solid #000000;
}

.swc-report .swc-report-table {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/MigrateUser.vue